import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";

export const chatLoader: LoaderFunction = async (args) => {
  if (args.params.cityCode === "new") {
    return new Promise((res) => res(Result.newResult()));
  }
  const result = await axiosApi.get("/api/chats/" + args.params.id);
  return result.data;
};
